import React, { Suspense } from 'react';
import { Route } from 'react-router';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';
import {
    mrsLocationSettings,
    saleShopSettings, stockLocationSettings, stockWarehouseSettings,
} from '../constants/constants';

const StockWarehousePage = React.lazy(() => import('../pages/StockWarehousePage/StockWarehouseSettingsPage'));
const MRSLocationSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/MRSLocationSettingsPage'));
const StockLocationSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/StockLocationSettingsPage'));
const SaleShopSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/SaleShopSettingsPage'));

const LocationSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={stockWarehouseSettings} exact component={StockWarehousePage} />
            <Route path={mrsLocationSettings} exact component={MRSLocationSettingsPage} />
            <Route path={stockLocationSettings} exact component={StockLocationSettingsPage} />
            <Route path={saleShopSettings} exact component={SaleShopSettingsPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default LocationSettingsRoutes;
